import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'construction-template',
    templateUrl: './construction-template.component.html',
    styleUrls: ['./construction-template.component.css']
})
export class ConstructionTemplateComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

}

